/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Daftar_TInputs */

const en_mk_tut_daftar_t = /** @type {(inputs: Mk_Tut_Daftar_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign up and sign in`)
};

const id_mk_tut_daftar_t = /** @type {(inputs: Mk_Tut_Daftar_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Daftar dan masuk`)
};

/**
* | output |
* | --- |
* | "Sign up and sign in" |
*
* @param {Mk_Tut_Daftar_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_daftar_t = /** @type {((inputs?: Mk_Tut_Daftar_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Daftar_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_daftar_t(inputs)
	return en_mk_tut_daftar_t(inputs)
});